module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<dl class=\'stepped zero\'>\n    <div class=\'two-column\'>\n        <div class=\'left-side\'>\n            <dt>ID</dt>\n            <dd>' +
((__t = ( id )) == null ? '' : __t) +
'</dd>\n\n            <dt>' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</dt>\n            <dd>' +
((__t = ( name )) == null ? '' : __t) +
'</dd>\n\n            <dt>' +
((__t = ( i18next.t('common.description') )) == null ? '' : __t) +
'</dt>\n            <dd>' +
((__t = ( description )) == null ? '' : __t) +
'</dd>\n\n            <dt>' +
((__t = ( i18next.t('glossary.created_by') )) == null ? '' : __t) +
'</dt>\n            <dd>' +
((__t = ( creatorName )) == null ? '' : __t) +
', ' +
((__t = ( created_at )) == null ? '' : __t) +
'</dd>\n\n            <dt>' +
((__t = ( i18next.t('glossary.last_change') )) == null ? '' : __t) +
'</dt>\n            <dd>' +
((__t = ( updaterName )) == null ? '' : __t) +
', ' +
((__t = ( updated_at )) == null ? '' : __t) +
'</dd>\n\n            <dt style="margin-top:15px"></dt>\n            <dd class=\'file-link\' id=\'file-link\'>\n                <span style=\'color:#8BC53F\'>' +
((__t = ( WiseMetering.icon('download') )) == null ? '' : __t) +
'</span>\n                <a class=\'link\' href="' +
((__t = ( file_link )) == null ? '' : __t) +
'" target="_blank">' +
((__t = ( original_filename )) == null ? '' : __t) +
'</a>\n            </dd>\n        </div>\n    </div>\n</dl>\n';

}
return __p
}